import type { TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";
import { DEUTSCHE_BAHN_SLUG } from "../constants";

export type DeutscheBahnResolvedApiPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      infoPath: string;
      bookingsPath: string;
      /** Hotel estimation POST path (v2). */
      estimationV2Path: string;
      /** Airline estimation POST path builder. */
      estimationAirlinePath: (iataCode: string) => string;
    };

function airlineTransportsBasePath(iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/transports/${DEUTSCHE_BAHN_SLUG}`;
}

/**
 * Resolves Deutsche Bahn API paths for hotel and airline contexts.
 * Same endpoints as the Airport Bus flow, with the `deutsche-bahn` transport-type segment.
 */
export function resolveDeutscheBahnApiPaths(
  transportContext: TransportAirlineApiContext
): DeutscheBahnResolvedApiPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }

  if (transportContext.mode === "airline") {
    return {
      kind: "ok",
      infoPath: airlineTransportsBasePath(transportContext.iataCode),
      bookingsPath: `v1/airports/${encodeURIComponent(transportContext.iataCode)}/bookings`,
      estimationV2Path: `v2/transport/${DEUTSCHE_BAHN_SLUG}`,
      estimationAirlinePath: airlineTransportsBasePath
    };
  }

  return {
    kind: "ok",
    infoPath: `transport/${DEUTSCHE_BAHN_SLUG}`,
    bookingsPath: "bookings",
    estimationV2Path: `v2/transport/${DEUTSCHE_BAHN_SLUG}`,
    estimationAirlinePath: airlineTransportsBasePath
  };
}
